import {Price} from "product/productDomain";
import isEmpty = require("lodash/isEmpty");


export enum UNIT_OF_MEASURE {
  pcs = 'pcs'
}


export function priceValue(priceObj: Price | number): number {
  if (isEmpty(priceObj)) {
    return null; // we do not want Error for empty price object
  } else if (isPrice(priceObj)) {
    return priceObj.price;
  } else if (typeof priceObj === 'number') {
    return priceObj;
  }
  throw new Error(`Expected Price or number, got '${priceObj}'.`);
}

function isPrice(priceObj: Price | number): priceObj is Price {
  return (<Price>priceObj).price !== undefined;
}



// WEBPACK FOOTER //
// ./src/product/productUtils.ts